export default "__VITE_ASSET__BTPeL0g9__"